import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AchieversComponent } from 'src/app/view/achievers/achievers.component';
import { BoardResultComponent } from 'src/app/view/achievers/board-result/board-result.component';
import { HouseClubCompetitionComponent } from 'src/app/view/achievers/house-club-competition/house-club-competition.component';
import { InterSchoolCompetitionComponent } from 'src/app/view/achievers/inter-school-competition/inter-school-competition.component';
import { SchoolResultComponent } from 'src/app/view/achievers/school-result/school-result.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    AchieversComponent,
    BoardResultComponent,
    SchoolResultComponent,
    InterSchoolCompetitionComponent,
    HouseClubCompetitionComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path:'',component:AchieversComponent,children: [
        {path:'board-result',component:BoardResultComponent},
        {path:'school-result',component:SchoolResultComponent},
        {path:'inter-school-competition',component:InterSchoolCompetitionComponent},
        {path:'house-club-competition',component:HouseClubCompetitionComponent},
      ]}
    ]),
    SharedModule
  ]
})
export class AchieversModule { }
